// src/pages/ProjectDetailsPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchProjectById } from "../../api/projectApi";
import { getActivitiesByProjectId } from "../../api/activityApi";
import { getTasksByActivityId } from "../../api/taskapi";
import ActivityTable from "../../components/ActivityTable";
import ProjectProgressCard from "../../components/ProjectProgressCard";
import TaskTable from "../../components/TaskTable";
import AddTaskModal from "./AddTaskModal";

const ProjectDetailsPage = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [activityTasks, setActivityTasks] = useState({});
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);

  useEffect(() => {
    fetchProjectById(id).then(setProject).catch(console.error);
    getActivitiesByProjectId(id).then(async (acts) => {
      setActivities(acts);
      const tasksMap = {};
      for (const activity of acts) {
        try {
          const tasks = await getTasksByActivityId(activity._id);
          tasksMap[activity._id] = tasks;
        } catch (err) {
          console.error(err);
        }
      }
      setActivityTasks(tasksMap);
    }).catch(console.error);
  }, [id]);

  const handleCreateTask = (activity) => {
    setSelectedActivity(activity);
    setShowAddTaskModal(true);
  };

  if (!project) return <div>Loading project...</div>;

  return (
    <div className="p-4 space-y-6">
      <ProjectProgressCard project={project} activities={activities} />

      <div>
        <h2 className="text-xl font-semibold mb-2">Activities</h2>
        {activities.map((activity) => (
          <div key={activity._id} className="mb-6 border rounded p-4 shadow">
            <ActivityTable
              projectId={id}
              activities={[activity]}
              onCreateTask={handleCreateTask}
            />
            <div className="mt-4">
              <h3 className="font-semibold text-lg mb-2">Tasks for Activity: {activity.title}</h3>
              <TaskTable tasks={activityTasks[activity._id] || []} />
            </div>
          </div>
        ))}
      </div>

      {showAddTaskModal && (
        <AddTaskModal
          activityId={selectedActivity?._id}
          onClose={() => setShowAddTaskModal(false)}
        />
      )}
    </div>
  );
};

export default ProjectDetailsPage;
